export const getJobTypeLabel = (value: string) => {
  switch (value) {
    case 'delivery_job':
      return 'Delivery Job'

    case 'cleaning_job':
      return "Cleaning Job"

    default:
      break;
  }

  return value
}

export const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const months = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

export const DEFAULT_DATEFORMAT = 'DD/MM/YYYY'
export const FALLBACK_DATE = '2000/01/01'

export const repeatOptions = [
  {
    name: "None",
    value: 'do_not_repeat'
  },{
    name: "Daily",
    value: "daily"
  },{
    name: "Weekly",
    value: "weekly"
  },{
    name: "Bi-Weekly",
    value: "biweekly"
  },{
    name: "Monthly",
    value: "monthly"
  }
]

export const getRepeatTypeLabel = (value: string) => {
  return repeatOptions.find((item) => item.value === value)?.name
}
export const sumOf = (arr: number[]) => arr.reduce((a, b) => a + b, 0)

export const includesIn = (text: string, list: string[]) => {
  return !!list.find((item) => text.includes(item))
}

export const removeEmptyValues = (obj: Record<string, any>) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== "" && value !== undefined && value !== null)
  );
}

export const getMapLabel = (value: number) => {
  if (value < 0) {
    return "B" + Math.abs(value)
  }
  if (value === 0) {
    return "G"
  }

  return value
}

export const getNumber = (text: string) => text.replace(/[^\d\.]*/g, '')